//import React from 'react'
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import VerifiedIcon from '@mui/icons-material/Verified';
import EditIcon from '@mui/icons-material/Edit';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
//import MenuItem from '@mui/material/MenuItem';
import React, { useState, useEffect } from "react";
import { useSession } from "../SessionContext";
import axios from "axios";
import SunEditor from "suneditor-react";
import "suneditor/dist/css/suneditor.min.css";
import { API_URL } from "../../config";
import { uploads } from "../../config";

// ✅ GET DOCTOR CATOGERY CHECKBOX
const DoctorCatCheckboxes = ({ value = "", options = [], onChange }) => {
    const [selected, setSelected] = useState([]);

    useEffect(() => {
        if (value) {
            setSelected(
                value.split(",").map(v => v.trim()).filter(Boolean)
            );
        } else {
            setSelected([]);
        }
    }, [value]);

    const toggle = (val) => {
        let updated;

        if (selected.includes(val)) {
            updated = selected.filter(v => v !== val);
        } else {
            updated = [...selected, val];
        }

        setSelected(updated);
        onChange(updated.join(","));
    };

    return (
        <div>
            {options.map((item) => (
                <label key={item.id} className='checkbox-label'>
                    <input
                        type="checkbox"
                        checked={selected.includes(item.name)}   // ✅ FIX
                        onChange={() => toggle(item.name)}       // ✅ FIX
                    />
                    {" "}{item.name}   {/* ✅ FIX */}
                </label>
            ))}
        </div>
    );
};

// ✅ GET DOCTOR TYPES CHECKBOX
const DoctorTypeCheckboxes = ({ value = "", options = [], onChange }) => {
    const [selected, setSelected] = useState([]);

    useEffect(() => {
        if (value) {
            setSelected(
                value.split(",").map(v => v.trim()).filter(Boolean)
            );
        } else {
            setSelected([]);
        }
    }, [value]);

    const toggle = (val) => {
        let updated;

        if (selected.includes(val)) {
            updated = selected.filter(v => v !== val);
        } else {
            updated = [...selected, val];
        }

        setSelected(updated);
        onChange(updated.join(","));
    };

    return (
        <div>
            {options.map((item) => (
                <label key={item.id} className='checkbox-label'>
                    <input
                        type="checkbox"
                        checked={selected.includes(item.name)}   // ✅ FIX
                        onChange={() => toggle(item.name)}       // ✅ FIX
                    />
                    {" "}{item.name}   {/* ✅ FIX */}
                </label>
            ))}
        </div>
    );
};

const DoctorBusinessDetailsForm = () => {
    const { session } = useSession();
    const [show, setShow] = useState(true);
    const [data, setData] = useState([]);
    const [formData, setFormData] = useState({});
    const [doctor_categories, setCategories] = useState([]);
    const [doctor_types, setTypes] = useState([]);
    const [errors, setErrors] = useState({});
    const [preview, setPreview] = useState("");

    // ✅ GET DOCTOR CATOGERY CHECKBOX
    useEffect(() => {
        fetch(`${API_URL}/api-all-table-filter.php?category=doctors`)
            .then((res) => res.json())
            .then((response) => {
                console.log(response);

                if (
                    response.status &&
                    response.data &&
                    response.data.length > 0
                ) {
                    const categoryString =
                        response.data[0].doctor_category || "";

                    const formatted = categoryString
                        .split(",")
                        .map((item, index) => ({
                            id: index,
                            name: item.trim(),
                        }));

                    setCategories(formatted);
                }
            })
            .catch((err) =>
                console.error("Error fetching categories:", err)
            );
    }, []);

    // ✅ GET DOCTOR TYPES CHECKBOX
    useEffect(() => {
        fetch(`${API_URL}/api-all-table-filter.php?category=doctors`)
            .then((res) => res.json())
            .then((response) => {
                console.log(response);

                if (
                    response.status &&
                    response.data &&
                    response.data.length > 0
                ) {
                    const categoryString =
                        response.data[0].doctor_type || "";

                    const formatted = categoryString
                        .split(",")
                        .map((item, index) => ({
                            id: index,
                            name: item.trim(),
                        }));

                    setTypes(formatted);
                }
            })
            .catch((err) =>
                console.error("Error fetching categories:", err)
            );
    }, []);

    // ✅ GET USER PERSONAL DETAILS
    useEffect(() => {
        axios
            .get(`${API_URL}/api-get-user-details.php`, {
                withCredentials: true,
            })
            .then((res) => {
                const user = res.data.data[0];
                setData(user);
                setFormData(user); // ✅ IMPORTANT: sync editable state

                // ✅ Set image preview dynamically
                if (user.business_logo) {
                    setPreview(`${uploads}/${user.business_logo}`);
                }
            })
            .catch((err) => console.log(err));
    }, []);


    // ✅ UPDATE API CALL
    const handleSave = () => {

        const isValid = validate();

        if (!isValid) {
            return; // ❌ STOP HERE if invalid
        }

        const payload = {
            user_id: session?.userid,
            business_fullname: formData.business_fullname,
            doctor_category: formData.doctor_category,
            doctor_type: formData.doctor_type,
            doctor_degree: formData.doctor_degree,
            doctor_work_area: formData.doctor_work_area,
            doctor_details: formData.doctor_details,
        };

        axios.post(
            `${API_URL}/api-update-business-details.php`,
            payload,
            {
                headers: {
                    "Content-Type": "application/json",
                },
                withCredentials: true,
            }
        )
            .then((res) => {
                alert("Updated Successfully!");

                setData(formData); // update UI
                setShow(true); // switch back to view mode
            })
            .catch((err) => {
                console.log(err);
                alert("Update Failed!");
            });
    };

    // ✅ FORM SHOW/HIDE EDIT AND CLOSE BUTTON CLICK
    function changeState() {
        setShow(!show);
    }

    // ✅ FORM VALIDATIONS
    const validate = () => {
        let temp = {};

        if (!formData.business_fullname?.trim()) {
            temp.business_fullname = "Doctor full name is required";
        }

        if (!formData.doctor_category?.trim()) {
            temp.doctor_category = "Doctor category is required";
        }

        if (!formData.doctor_type?.trim()) {
            temp.doctor_type = "Doctor type is required";
        }

        if (!formData.doctor_degree?.trim()) {
            temp.doctor_degree = "Qualification is required";
        }

        if (!formData.doctor_work_area?.trim()) {
            temp.doctor_work_area = "Work area is required";
        }

        if (!formData.doctor_details?.trim()) {
            temp.doctor_details = "About doctor is required";
        }

        setErrors(temp);

        return Object.keys(temp).length === 0;
    };
    return (
        <div className='bd-right-panel fade-in'>
            <p style={{ display: "none" }}>User ID: {session?.userid} | Category: {session?.ucategory} | Email: {session?.email}</p>

            <div className='comp-details'>
                <div className='logo-box'>
                    <img src={preview || "/images/default-profile-pic.jpg"} className="fullimg" alt={data.business_fullname}
                        onError={(e) => {
                            e.target.onerror = null; // prevent infinite loop
                            e.target.src = "/images/default-profile-pic.jpg";
                        }} />
                </div>
                <div className='title-box'><VerifiedIcon /> {data?.user_first_name || ""} {data?.user_middle_name || ""} {data?.user_last_name || ""}</div>
                <div className='location-box'>
                    <FmdGoodOutlinedIcon />
                    {data?.business_address ? `${data.business_address}, ` : ""}
                    {data?.business_city ? `${data.business_city}, ` : ""}
                    {data?.business_district ? `${data.business_district}, ` : ""}
                    {data?.business_state ? `${data.business_state} - ` : ""}
                    {data?.business_zipcode || ""}
                </div>
            </div>
            <div className='clr'></div>
            <div className='devider'></div>
            <div className='db-form-panel'>
                <div className='heading'>
                    <h2>Business Details:</h2>
                    {show ? (
                        <div className='edit-btnbox' onClick={changeState} ><EditIcon /> Edit</div>
                    ) : (
                        <div className='close-btnbox' onClick={changeState} ><CloseIcon /> Close</div>
                    )}
                    <div className='clr'></div>
                </div>
                {show ? (
                    <div className='db-form-details'>
                        <div className='row'>
                            <div className='col-md-12'><div className='db-form-row'><TextField disabled id="outlined-disabled" className='db-textbox' label="Doctor Full Name" value={data?.business_fullname || ""} /></div></div>
                            <div className='col-md-12'><div className='db-form-row'><TextField disabled id="outlined-disabled" className='db-textbox' label="Doctor Category" value={data?.doctor_category || ""} /></div></div>
                            <div className='col-md-12'><div className='db-form-row'><TextField disabled id="outlined-disabled" className='db-textbox' label="Doctor Type" value={data?.doctor_type || ""} /></div></div>
                            <div className='col-md-12'><div className='db-form-row'><TextField disabled id="outlined-disabled" className='db-textbox' label="Doctor Qualification" value={data?.doctor_degree || ""} /></div></div>
                            <div className='col-md-12'><div className='db-form-row'><TextField disabled id="outlined-disabled" className='db-textbox' label="Doctory Work Area" value={data?.doctor_work_area || ""} multiline minRows={4} /></div></div>
                            <div className='col-md-12'>
                                <div className='db-form-row'>
                                    <div className='form-label'>About Doctor </div>
                                    <SunEditor disable={true} setContents={formData.doctor_details || ""}
                                        setOptions={{
                                            height: 300,
                                            buttonList: [["formatBlock"], ["bold", "italic", "underline"], ["list", "align"],],
                                        }} onChange={(text) => setFormData((prev) => ({ ...prev, doctor_details: text, }))}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className='db-form-details'>
                        <div className='row'>
                            <div className='col-md-12'><div className='db-form-row'><TextField className='db-textbox' label="Doctor Full Name" value={formData.business_fullname || ""} onChange={(e) => setFormData({ ...formData, business_fullname: e.target.value })} error={!!errors.business_fullname} helperText={errors.business_fullname} /></div></div>
                            <div className='col-md-12'>
                                <div className='db-form-row'>
                                    <TextField className='db-textbox' label="Doctor Category" value={formData.doctor_category || ""} onChange={(e) => setFormData({ ...formData, doctor_category: e.target.value })} error={!!errors.doctor_category} helperText={errors.doctor_category} />
                                    <DoctorCatCheckboxes value={formData.doctor_category || ""} options={doctor_categories} onChange={(val) => setFormData({ ...formData, doctor_category: val })} />
                                </div>
                            </div>
                            <div className='col-md-12'>
                                <div className='db-form-row'>
                                    <TextField className='db-textbox' label="Doctor Type" value={formData.doctor_type || ""} onChange={(e) => setFormData({ ...formData, doctor_type: e.target.value })} error={!!errors.doctor_type} helperText={errors.doctor_type} />
                                    <DoctorTypeCheckboxes value={formData.doctor_type || ""} options={doctor_types} onChange={(val) => setFormData({ ...formData, doctor_type: val })} />
                                </div>
                            </div>
                            <div className='col-md-12'><div className='db-form-row'><TextField className='db-textbox' label="Doctor Qualification" value={formData.doctor_degree || ""} onChange={(e) => setFormData({ ...formData, doctor_degree: e.target.value })} error={!!errors.doctor_degree} helperText={errors.doctor_degree} /></div></div>
                            <div className='col-md-12'><div className='db-form-row'><TextField className='db-textbox' label="Doctory Work Area" value={formData.doctor_work_area || ""} onChange={(e) => setFormData({ ...formData, doctor_work_area: e.target.value })} multiline minRows={4} error={!!errors.doctor_work_area} helperText={errors.doctor_work_area} /></div></div>
                            <div className='col-md-12'>
                                <div className='db-form-row'>
                                    <div className='form-label'>About Doctor </div>
                                    <SunEditor setContents={formData.doctor_details || ""}
                                        setOptions={{
                                            height: 300,
                                            buttonList: [["formatBlock"], ["bold", "italic", "underline"], ["list", "align"],],
                                        }} onChange={(text) => setFormData((prev) => ({ ...prev, doctor_details: text, }))}
                                    />
                                </div>
                            </div>

                            <div className='col-md-12'>
                                <div className='db-form-row'>
                                    <div style={{ textAlign: "center" }}>
                                        <button onClick={handleSave} className="update-btn">
                                            Save Changes
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
}

export default DoctorBusinessDetailsForm
